import React, { useState } from "react";
import { AiOutlineMinus, AiOutlinePlus } from "react-icons/ai";
import data from "./data";

const Question = () => {
  const [expanded, setExpanded] = useState({});

  return (
    <main>
      <div className="container">
        <h3>Questions And Answers About Login</h3>
        <section className="info">
          {data.map((question) => {
            const { id, title, info } = question;
            return (
              <article key={id} className="question">
                <header>
                  <h4>{title}</h4>
                  <button
                    className="btn"
                    onClick={() =>
                      setExpanded({ ...expanded, [id]: !expanded[id] })
                    }
                  >
                    {expanded[id] ? <AiOutlineMinus /> : <AiOutlinePlus />}
                  </button>
                </header>
                <p>{expanded[id] ? info : null}</p>
              </article>
            );
          })}
        </section>
      </div>
    </main>
  );
};

export default Question;
